import ActiveEmployees from "../../components/allocation-dashboard/activeEmployee";

type Props = {
  show: boolean;
  onClose: () => void;
  onSave: () => void;
  currentDesigner: string;
  currentCaptain: string;
  onDesignerChange: (value: string) => void;
  onCaptainChange: (value: string) => void;
  employee: any;
  user: any;
  passkey: string;
  editNote: string;
  setEditNote: (value: string) => void;
  setPasskey: (value: string) => void;
};

const EditAllocationModal: React.FC<Props> = ({
  show,
  onClose,
  onSave,
  currentDesigner,
  currentCaptain,
  onDesignerChange,
  onCaptainChange,
  employee,
  user,
  passkey,
  setPasskey,
  editNote,
  setEditNote,
}) => {
  if (!show) return null;

  const isAdmin = user?.role === "Super Admin";
  const shouldShowPasskey = !employee && !isAdmin;

  const isDisabled =
    !currentDesigner || !currentCaptain || (shouldShowPasskey && !passkey);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white w-[500px] rounded-xl shadow-lg p-6 relative">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold">Edit Allocation</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-black text-lg"
          >
            ✕
          </button>
        </div>

        {/* Current Selection Display */}
        <div className="mb-4 text-sm text-gray-600">
          <p>
            <span className="font-medium">Current Designer:</span>{" "}
            {currentDesigner}
          </p>
          <p>
            <span className="font-medium">Current Captain:</span>{" "}
            {currentCaptain}
          </p>
        </div>

        {/* Passkey Field (Only if not employee & not admin) */}
        {shouldShowPasskey && (
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">
              Enter Passkey
            </label>
            <input
              type="password"
              value={passkey}
              onChange={(e) => setPasskey(e.target.value)}
              className="w-full border px-3 py-1.5 rounded-md text-sm"
              placeholder="Enter your passkey"
            />
          </div>
        )}

        {/* Employee Selection */}
        <div className="mb-6">
          <ActiveEmployees
            selectedDesigner={currentDesigner}
            selectedCaptain={currentCaptain}
            onSelect={(role, name) => {
              if (role === "Designer") {
                onDesignerChange(name);
              } else {
                onCaptainChange(name);
              }
            }}
            isAll={true}
          />
        </div>
        {/* Note Field */}
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">
            Edit Note
          </label>
          <textarea
            rows={3}
            value={editNote}
            onChange={(e) => setEditNote(e.target.value)}
            className="w-full border px-3 py-2 rounded-md text-sm resize-none"
            placeholder="Enter edit note..."
          />
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-1.5 text-sm rounded-md bg-gray-300 hover:bg-gray-400"
          >
            Cancel
          </button>

          <button
            disabled={isDisabled}
            onClick={onSave}
            className={`px-4 py-1.5 text-sm rounded-md text-white transition ${isDisabled
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-blue-600 hover:bg-blue-700"
              }`}
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditAllocationModal;
